export default __webpack_public_path__ + "static/media/ruinouspower.f88f554d.png";